import {combineReducers} from 'redux';
import authServiceReducer from './authServiceReducer';
import facilityReducer from './facilityReducer' ;
import restCallTestReducer from './restCallTestReducer';
import placesReducer from './placesReducer';
import manageTenantRouter from './manageTenantRouteReducer';
import zonesReducer from './ZonesReducer' ;
import holidaysReducer from './HolidaysReducer' ;
import BuildingAndMembersReducer from './BuildingReducer' ;
import tenantreducer from './TenantsReducer' ;
import viewTenantDetailreducer from './ViewTenantsReducer' ;
import userPreferencesReducer from './UserPreferencesReducer' ;
import employeeReducer from './EmployeeReducer';
import TenantMeterReducer from './tenantMeterReducer';
import temperatureAdjustmentsReducer from './TemperatureAdjustmentsReducer';
import requestReducer from './requestReducer';
import invoiceReducer from './invoiceReducer';
import InstallationsReducer from './Administration/InstallationReducer';
import ManageDashboardsReducer from './DashboardReducer/ManageDashboardsReducer';
import ViewDashboardReducer from './DashboardReducer/ViewDashboardReducer';
import WorkorderReducer from './WorkorderReducer';
import HubManagementReducer from './HubManagementReducer';
import ManageReportsReducer from 'reducers/ReportsReducer/ManageReportsReducer';
import ReportDesignerRootReducer from 'reducers/ReportsReducer/ReportDesignerReducer';
import FacilityRequestsReducer from 'reducers/FacilityRequests/FacilityRequestsReducer';
import ASUBillingInvoicesReducer from './ASUReducer/BillingInvoicesReducer';
import DataExportReducer from 'reducers/ReportsReducer/DataExportReducer';
import ScheduleReportsReducer from 'reducers/ReportsReducer/ScheduleReportReducer';

const rootReducer = combineReducers(
    {
    zonesRootReducer: zonesReducer,
    tenantsRootReducer: tenantreducer,
    ViewtenantsRootReducer: viewTenantDetailreducer,
    userDetailsRootReducer: userPreferencesReducer.UserDetailsReducer,
    userPreferencesRootReducer: userPreferencesReducer.PreferencesReducer,
    CulturalLabelsRootReducer: userPreferencesReducer.CulturalLabelsReducer,
    CommonResourceDataRootReducer: userPreferencesReducer.CommonResourceReducer,
    authService:authServiceReducer, 
    // facility: facilityReducer, 
    facilityRootReducer: facilityReducer, 
    restCallTest: restCallTestReducer, 
    placesRootReducer : placesReducer,
    manageTenant: manageTenantRouter,
    buildingsRootReducer: BuildingAndMembersReducer.BuildingReducer,
    MembersRootReducer: BuildingAndMembersReducer.MembersReducer,
    TenantMeterReducer: TenantMeterReducer.MeterReducer,
    BuildingDetailsReducer: BuildingAndMembersReducer.BuildingDetailsReducer,
    BuildingFamilyReducer:BuildingAndMembersReducer.BuildingFamilyReducer,
    BuildingsEquipmentObjectReducer:BuildingAndMembersReducer.BuildingEquipmentObjectsReducer,
    BuildingPointsReducer:BuildingAndMembersReducer.BuildingPointsReducer,
    BuildingEquipmentPointsReducer:BuildingAndMembersReducer.BuildingEquipmentPointsReducer,
    BuildingUnitsReducer:BuildingAndMembersReducer.BuildingUnitsReducer,
    BuildingDatalogObjectsReducer:BuildingAndMembersReducer.BuildingDatalogObjectsReducer,
    GetHolidayReducer: holidaysReducer.GetHolidayReducer,
    HolidaysRootReducer: holidaysReducer.AllHolidaysReducer,
    SaveHolidayReducer: holidaysReducer.SaveHolidayReducer,
    EmployeeRootReducer: employeeReducer,
    ModalOpenCloseRootReducer: userPreferencesReducer.ModalOpenCloseReducer,
    FacilityDisplayStateRootReducer: userPreferencesReducer.FacilityDisplayState,
    TempAdjustmentsRootReducer: temperatureAdjustmentsReducer,
    
    RequestRootReducer: requestReducer,
    InvoiceRootReducer: invoiceReducer,
    InstallationsRootReducer: InstallationsReducer,
	ManageDashboardsRootReducer: ManageDashboardsReducer,
    ViewDashboardRootReducer: ViewDashboardReducer,
    
    //Workorder
    WorkorderRootReducer: WorkorderReducer,

    // HubManagement
    HubManagementRootReducer: HubManagementReducer,
   
    //Report Mangement System
    ManageReportsRootReducer: ManageReportsReducer.ManageReportsListReducer,
    ManageReportsSubListRootReducer: ManageReportsReducer.ManageReportsSubListReducer,
    RunReportsRootReducer: ManageReportsReducer.RunReportsReducer,
    ReportDesignerRootReducer: ReportDesignerRootReducer,

    //Data Export
    DataExportDatalogDefinitionsReducer: DataExportReducer.DataExportDatalogDefinitionsReducer,
    DataExportEquipmentListReducer: DataExportReducer.EquipmentListReducer,
    DataExportEquipmentPropertiesReducer: DataExportReducer.EquipmentPropertiesReducer,
    DataExportFamilyTypeReducer: DataExportReducer.FamilyTypeReducer,
    DataExportDataSourceReducer: DataExportReducer.DataSourceReducer,
    DataExportBuildingReducer: DataExportReducer.BuildingReducer,

    //Facility Requests
    FacilityRequestsMyRequestsRootReducer: FacilityRequestsReducer.FacilityRequestsMyRequestsListReducer,
    FacilityRequestsAllRequestsRootReducer: FacilityRequestsReducer.FacilityRequestsAllRequestsListReducer,
    FacilityRequestsEmployeeTenantDetails: FacilityRequestsReducer.FacilityRequestsEmployeeTenantDetails,

    //ASU Billing Invoices
    ASUBillingInvoicesRootReducer: ASUBillingInvoicesReducer,

    //Schedule Report
    ScheduleReportRootReducer: ScheduleReportsReducer,

});

export default rootReducer;